// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {
  Col,
  Row,
  NavBar,
  Button,
  Progress,
  Icon,
  Image as VanImage,
  Divider,
  List,
  Cell,
  CellGroup,
  Skeleton,
  Loading,
  ImagePreview,
  Lazyload,
  Swipe,
  SwipeItem,
  PullRefresh,
  Field,
  Cascader,
  Popup,
  Uploader,
  Form,
  Area,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  NoticeBar,
  Stepper,
  Overlay,
  Step,
  Steps,
  Card,
  SubmitBar,
  Grid,
  GridItem,
  Tab,
  Tabs,
  Empty,
  Picker
} from 'vant'
import App from './App'
import router from './router'
import wx from '@/service/wx'
import user from '@/service/user'

import VueWechatTitle from 'vue-wechat-title'

Vue.use(Col)
Vue.use(Row)
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Progress)
Vue.use(Icon)
Vue.use(VanImage)
Vue.use(Divider)
Vue.use(List)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Skeleton)
Vue.use(Loading)
Vue.use(ImagePreview)
Vue.use(Lazyload)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(PullRefresh)
Vue.use(Field)
Vue.use(Cascader)
Vue.use(Popup)
Vue.use(Uploader)
Vue.use(Stepper)
Vue.use(Form)
Vue.use(Area)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(NoticeBar)
Vue.use(Overlay)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Card)
Vue.use(SubmitBar)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Empty)
Vue.use(Picker)
Vue.use(VueWechatTitle)

const isDebug = process.env.NODE_ENV !== 'production'
// const isDebug = false
Vue.config.debug = isDebug
Vue.config.devtools = isDebug
Vue.config.productionTip = isDebug

// router.afterEach((to, from) => {
//   this.$nextTick(() => {
//     document.body.scrollTop = 0
//   })
// })

router.beforeEach((to, from, next) => {
  // 跳转页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 回到顶部
  document.body.scrollTop = 0
  if (isDebug) {
    if (!sessionStorage.getItem('token')) {
      sessionStorage.setItem('token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiJvR3RneTZpNGVlNjNZZ05obWEwbnhNOWVleWljIiwiZGV2aWNlIjoiZGVmYXVsdC1kZXZpY2UiLCJlZmYiOjE3Njk5NjQyMDgyMTksImlzQWRtaW4iOnRydWV9.wx2LwZNM9v9nl4cxnp3c2iTNL1Zeq8FM-QdcJin7qwA')
      sessionStorage.setItem('nickname', 'Cookie')
      sessionStorage.setItem('headImgUrl', 'https://thirdwx.qlogo.cn/mmopen/vi_32/yibsjCy2qf10Kmacs3PPnx6CWonCshPibaVM7PaVPia8GxoAszoABHXYnwygrAYLbDxDHncfic1cvDajjiaI3jI7NHg/132')
    }
    next()
  } else {
    // 判断页面是否需要登录
    if (to.meta.requireAuth) {
      // 需要登录
      const tokenParam = new URLSearchParams(window.location.search).get('token')
      const localToken = sessionStorage.getItem('token')
      // URL有token && 本地没有token 才初始化
      if (tokenParam && !localToken) {
        sessionStorage.setItem('token', tokenParam)

        const newQuery = { ...to.query }
        delete newQuery.token

        user.getUserInfo2().then(result => {
          sessionStorage.setItem('openId', result.data.openId)
          sessionStorage.setItem('nickname', result.data.nickname)
          sessionStorage.setItem('headImgUrl', result.data.headImgUrl)

          next({
            path: to.path,
            query: newQuery,
            hash: to.hash,
            replace: true
          })
        })
        return
      }
      const token = sessionStorage.getItem('token')
      const openid = sessionStorage.getItem('openId')
      // 判断用户是否登录
      if (token && openid) {
        // 已登录
        next()
      } else {
        // 未登陆，跳转登录页面
        wx.login(to.fullPath)
      }
    } else {
      // 页面不需要登录
      next()
    }
  }
})

// 这要放在beforeEach下面，不要问为什么，问就是自己试
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js